import { format } from "@/utils/format"

export default function (dom, opts) {
	let options = {
		...opts
	}

	try {
		const checkbox = dom.querySelector(options.checkboxSelector)
		const selectTemplate = dom.querySelector(options.selectTemplate)
		const inputTemplate = dom.querySelector(options.inputTemplate)
		const selectWrapper = selectTemplate.content.firstElementChild.cloneNode(true)
		const selectElement = selectWrapper.querySelector('select')
		const inputWrappers = []

		const addSelect = () => {
			if (!dom.contains(selectWrapper)) {
				dom.appendChild(selectWrapper)
			}
			handleSelect()
		}

		const removeSelect = () => {
			if (dom.contains(selectWrapper)) {
				dom.removeChild(selectWrapper)
			}
			selectElement.value = selectElement.firstElementChild.value
			handleSelect()
		}

		const handleCheckbox = e => {
			if (checkbox.checked) {
				addSelect()
			} else {
				removeSelect()
			}
		}

		const handleSelect = e => {
			if (checkbox.checked) {
				updateInputs(selectElement.value)
			} else {
				updateInputs(0)
			}
		}

		const updateInputs = count => {
			const existing = inputWrappers.length
			const change = count - existing
			if (change > 0) {
				for (let i = existing; i < existing + change; i++) {
					addInput(i)
				}
			}
			else if (change < 0) {
				for (let i = existing; i > existing + change; i--) {
					removeInput(i)
				}
			}
		}

		const addInput = index => {
			const i = index + 1
			const inputHtml = format(inputTemplate.innerHTML, { i })
			const div = document.createElement('div')
			div.innerHTML = inputHtml
			const inputElement = div.firstElementChild
			dom.appendChild(inputElement)
			inputWrappers.push(inputElement)
		}

		const removeInput = index => {
			const el = inputWrappers.pop()
			dom.removeChild(el)
		}


		const init = () => {
			checkbox.addEventListener('input', handleCheckbox)
			selectElement.addEventListener('input', handleSelect)

			handleCheckbox()
			handleSelect()

			if (options.hasErrors && options.data?.text) {
				Object.values(options.data.text).forEach((t, i) => {
					const inputWrapper = inputWrappers[i]
					if (inputWrapper) {
						const input = inputWrapper.querySelector('input')
						const error = inputWrapper.querySelector('.error')

						input.value = t
						error.style.display = t.trim() === '' ? 'block' : 'none'
					}
				})
			}
		}

		init()
	} catch(err) {
		console.error(err)
		dom.style.opacity = 0.5
		dom.style.cursor = 'not-allowed'
		const input = dom.querySelector('input')
		const label = dom.querySelector('label')
		if (input) {
			input.disabled = true
			input.checked = false
			input.style.pointerEvents = 'none'
		}
		if (label) {
			label.style.pointerEvents = 'none'
		}
	}
}
